import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home'
Vue.use(Router)


export default new Router({
    routes: [{
            path: '/home',
            name: 'home',
            alias: '/',
            component: Home,
            meta: {},
        },
        {path: '/intro',
            name: 'intro',
            component: () => import ('./views/Intro'),
        },
        {path: '/scenario-menu',
            name: 'scenario-menu',
            component: () => import ('./views/ScenarioMenu'),
        },
        {path: '/scenario',
            component: () => import ('./views/Scenario'),
            children: [
                {path: '', redirect: 'drug-enforcement'},

                {path: 'drug-enforcement',
                    component: () => import ('./views/scenario_pages/de_view'),
                    children: [
                        {path: '',
                        redirect: {name: 'drug_enforcement-splash'}
                        },
                        {path: 'splash',
                            name: 'drug_enforcement-splash',
                            component: () => import ('./views/scenario_pages/drug-enforcement/de_splash')
                        },
                        {path: 'stage-1',
                            component: () => import ('./views/scenario_pages/drug-enforcement/de_stage-1')
                        },
                        {path: 'stage-2',
                            component: () => import ('./views/scenario_pages/drug-enforcement/de_stage-2')
                        },
                        {path: 'stage-3',
                            component: () => import ('./views/scenario_pages/drug-enforcement/de_stage-3')
                        },
                        {path: 'stage-4',
                            component: () => import ('./views/scenario_pages/drug-enforcement/de_stage-4')
                        },
                        {path: 'stage-5',
                            component: () => import ('./views/scenario_pages/drug-enforcement/de_stage-5')
                        },
                        {path: 'stage-6',
                            component: () => import ('./views/scenario_pages/drug-enforcement/de_stage-6')
                        },
                    ]
                },

                {path: 'expeditionary',
                    component: () => import ('./views/scenario_pages/e_view'),
                    children: [
                        {path: '',
                            redirect: {name: 'expeditionary-splash'}
                        },
                        {path: 'splash',
                            name: 'expeditionary-splash',
                            component: () => import ('./views/scenario_pages/expeditionary/e_splash')
                        },
                        {path: 'stage-1',
                            component: () => import ('./views/scenario_pages/expeditionary/e_stage-1')
                        },
                        {path: 'stage-2',
                            component: () => import ('./views/scenario_pages/expeditionary/e_stage-2')
                        },
                        {path: 'stage-3',
                            component: () => import ('./views/scenario_pages/expeditionary/e_stage-3')
                        },
                        {path: 'stage-4',
                            component: () => import ('./views/scenario_pages/expeditionary/e_stage-4')
                        },
                        {path: 'stage-5',
                            component: () => import ('./views/scenario_pages/expeditionary/e_stage-5'),
                        },
                        {path: 'stage-6',
                            component: () => import ('./views/scenario_pages/expeditionary/e_stage-6'),
                        },
                    ]
                },

                {path: 'military-base',
                    component: () => import ('./views/scenario_pages/mb_view'),
                    children: [
                        {path: '',
                        redirect: {name: 'military_base-splash'}
                        },
                        {path: 'splash',
                            name: 'military_base-splash',
                            component: () => import ('./views/scenario_pages/military-base/mb_splash')
                        },
                        {path: 'stage-1',
                            component: () => import ('./views/scenario_pages/military-base/mb_stage-1')
                        },
                        {path: 'stage-2',
                            component: () => import ('./views/scenario_pages/military-base/mb_stage-2')
                        },
                        {path: 'stage-3',
                            component: () => import ('./views/scenario_pages/military-base/mb_stage-3')
                        },
                        {path: 'stage-4',
                            component: () => import ('./views/scenario_pages/military-base/mb_stage-4')
                        },
                        {path: 'stage-5',
                            component: () => import ('./views/scenario_pages/military-base/mb_stage-5')
                        },
                    ]
                },

                {path: 'disaster-relief',
                    component: () => import ('./views/scenario_pages/dr_view'),
                    children: [
                        {path: '',
                        redirect: {name: 'disaster_relief-splash'}
                        },
                        {path: 'splash',
                            name: 'disaster_relief-splash',
                            component: () => import ('./views/scenario_pages/disaster-relief/dr_splash')
                        },
                        {path: 'stage-1',
                            component: () => import ('./views/scenario_pages/disaster-relief/dr_stage-1')
                        },
                        {path: 'stage-2',
                            component: () => import ('./views/scenario_pages/disaster-relief/dr_stage-2')
                        },
                        {path: 'stage-3',
                            component: () => import ('./views/scenario_pages/disaster-relief/dr_stage-3')
                        },
                        {path: 'stage-4',
                            component: () => import ('./views/scenario_pages/disaster-relief/dr_stage-4')
                        },
                        {path: 'stage-5',
                            component: () => import ('./views/scenario_pages/disaster-relief/dr_stage-5')
                        },
                        // {path: 'stage-6',
                        //     component: () => import ('./views/scenario_pages/disaster-relief/dr_stage-6')
                        // },
                    ]
                },

                {path: 'airbase',
                    component: () => import ('./views/scenario_pages/a_view'),
                    children: [
                        {path: '',
                            redirect: {name: 'airbase-splash'}
                        },
                        {path: 'splash',
                            name: 'airbase-splash',
                            component: () => import ('./views/scenario_pages/airbase/a_splash')
                        },
                        {path: 'stage-1',
                            component: () => import ('./views/scenario_pages/airbase/a_stage-1')
                        },
                        {path: 'stage-2',
                            component: () => import ('./views/scenario_pages/airbase/a_stage-2')
                        },
                        {path: 'stage-3',
                            component: () => import ('./views/scenario_pages/airbase/a_stage-3')
                        },
                        {path: 'stage-4',
                            component: () => import ('./views/scenario_pages/airbase/a_stage-4')
                        },
                        {path: 'stage-5',
                            component: () => import ('./views/scenario_pages/airbase/a_stage-5')
                        },
                        {path: 'stage-6',
                            component: () => import ('./views/scenario_pages/airbase/a_stage-6'),
                        },
                    ]
                },

            ]
        },
        {path: '/keybenefits',
            name: 'keybenefits',
            component: () => import ('./views/KeyBenefits'),
        },
    ]
})